import { useNavigate } from '@remix-run/react';
import { useCallback } from 'react';

/**
 * 重新加载某个 url 的页面：
 * @returns
 */
export function useRevalidate() {
  const navigate = useNavigate();
  return useCallback((url = '.') => {
    navigate(url, { replace: true, relative: 'route', state: Math.random() });
  }, [navigate]);
}
